<template>
	<svg id="left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
		<path d="M129,148.11l-27.28-27.28h64.61a8.33,8.33,0,0,0,8.33-8.33v-25a8.33,8.33,0,0,0-8.33-8.33H101.67L129,51.89a8.32,8.32,0,0,0,0-11.78L111.28,22.44a8.34,8.34,0,0,0-11.78,0L27.83,94.11a8.34,8.34,0,0,0,0,11.78L99.5,177.56a8.34,8.34,0,0,0,11.78,0L129,159.89A8.32,8.32,0,0,0,129,148.11Z"/>
	</svg>
</template>

<script>
export default {
	name: "LeftArrow"
}
</script>
